<template>
  <div>
    <div class="e-loader-back" v-if="loading">
          <div class="e-loader-content">
            <div class="ball-clip-rotate-multiple">
              <div></div>
              <div></div>
            </div>
            <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
          </div>
        </div>
    <b-modal id="addNewTr" size="lg" class="modal has-overflow">
      <template v-slot:modal-header>
        <div class="w-100">
          <h4 class="e-mtavr-17 e-bold modal-title">ახალი ტრანზაქცია</h4>
        </div>
      </template>
      <form autocomplete="off">
        <div class="row no-gutters row-bordered">
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pr-3">
             <h5
                class="text-center py-4 px-4 px-sm-5 m-0 e-mtavr-14 text-muted"
              >კლიენტის მონაცემები</h5>
              <hr class="border-light m-0 mb-3" />
            <b-form-group
              label="აირჩიე ორგანიზაცია"
              class="e-nusx-8 e-bold text-muted"
            >
              <!-- <b-input v-model="newUserItem.user.firstName" class="e-eng-font" /> -->
               <b-select v-model="NewTransactionItem.orgid"  class="e-nusx-7 custom-select custom-select-sm" @change="filterAclicks()">
                      <option v-for="o in orgs" :key="o.$index" :value="o.id">{{o.name}}</option>
                </b-select>
            </b-form-group>
            <b-form-group
              label="PO-თი შესყიდული კლიკების რაოდენობა"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input v-model="CurrentSearches.purchasedSearchCount" class="e-eng-font" size="sm"/>
            </b-form-group>
            <b-form-group
              label="გააქტიურებული კლიკების რაოდენობა"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input v-model="CurrentSearches.activatedSeearchCount" class="e-eng-font" size="sm"/>
            </b-form-group>
            <b-form-group
              label="PO-ს დაწყების თარიღი"
              class="e-nusx-8 e-bold text-muted"
            >
              <datepicker
                          id="bdate"
                          v-model="CurrentSearches.currentPOStartDate"
                          :bootstrapStyling="true"
                          :language="locale"
                          :monday-first="true"
                          placeholder="თარიღი არ არის არჩეული"
                          :calendar-button="true"
                          calendar-button-icon="far fa-calendar-alt"
                          format="dd.MM.yyyy"
                        />
            </b-form-group>
            <b-form-group
              label="PO-ს დასრულების თარიღი"
              class="e-nusx-8 e-bold text-muted"
            >
              <datepicker
                          id="bdate"
                          v-model="CurrentSearches.currentPOEndDate"
                          :bootstrapStyling="true"
                          :language="locale"
                          :monday-first="true"
                          placeholder="თარიღი არ არის არჩეული"
                          :calendar-button="true"
                          calendar-button-icon="far fa-calendar-alt"
                          format="dd.MM.yyyy"
                        />
            </b-form-group>
          <!-- <datepicker
                          id="bdate"
                          v-model="newReqItem.brthDate"
                          :bootstrapStyling="true"
                          :language="locale"
                          :monday-first="true"
                          placeholder="თარიღი არ არის არჩეული"
                          :calendar-button="true"
                          calendar-button-icon="far fa-calendar-alt"
                          format="dd.MM.yyyy"
                        /> -->
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-3">
            <h5
                class="text-center py-4 px-4 px-sm-5 m-0 e-mtavr-14 text-muted"
              >შესყიდვის დეტალები</h5>
              <hr class="border-light m-0 mb-3" />
            <b-form-group
              label="გასააქტიურებელი კლიკების რაოდენობა"
              class="e-nusx-8 e-bold text-muted"
            >
              <b-input v-model="NewTransactionItem.transactionSearchCount" class="e-eng-font" size="sm"/>
            </b-form-group>
            <b-form-group
              label="გააქტიურების თარიღი"
              class="e-nusx-8 e-bold text-muted"
            >
              <datepicker
                          id="bdate"
                          v-model="NewTransactionItem.activationDateTime"
                          :bootstrapStyling="true"
                          :language="locale"
                          :monday-first="true"
                          placeholder="თარიღი არ არის არჩეული"
                          :calendar-button="true"
                          calendar-button-icon="far fa-calendar-alt"
                          format="dd.MM.yyyy"
                        />
            </b-form-group>
            <b-form-group
              label=" კლიკების გამოყენების პერიოდი"
              class="e-nusx-8 e-bold text-muted"
            >
              <datepicker
                          id="bdate"
                          v-model="NewTransactionItem.searchesEndDate"
                          :bootstrapStyling="true"
                          :language="locale"
                          :monday-first="true"
                          placeholder="თარიღი არ არის არჩეული"
                          :calendar-button="true"
                          calendar-button-icon="far fa-calendar-alt"
                          format="dd.MM.yyyy"
                        />
            </b-form-group>
            <b-form-group
              label="აქტივაციის მეთოდი"
              class="e-nusx-8 e-bold text-muted"
            >
              <!-- <b-input v-model="newUserItem.user.firstName" class="e-eng-font" /> -->
               <b-select v-model="NewTransactionItem.transactionTypeId"  class="e-nusx-7 custom-select custom-select-sm">
                      <option :value="1">ახალი PO-ს პირველი პორციის გააქტიურება </option>
                      <option :value="2">მიმდინარე PO-ს მორიგი პორციის გააქტიურება </option>
                </b-select>
            </b-form-group>

          </div>
        </div>
      </form>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button
            size="sm"
            variant="btn btn-primary"
            @click="save()"
            class="float-right e-mtavr-17"
            >შენახვა</b-button
          >
          <b-button
            size="sm"
            variant="btn btn-secondary"
            @click="close('addNewUser')"
            class="float-right e-mtavr-17 mr-2"
            >გაუქმება</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import BaseService from '@/backend/vue-axios/axios.js'
import moment from 'moment'
import { ge } from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
export default {
  name: 'AddNewTrModal',
  components: {
    Datepicker
  },
  data () {
    return {
      loading: false,
      currentUser: this.$store.getters.GetCurrentUser,
      locale: ge,
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      NewTransactionItem: {
        orgid: 0,
        orgname: '',
        activatedSeearchCount: 0,
        transactionSearchCount: 0,
        activationDateTime: 0,
        searchesEndDate: null,
        transactionTypeId: 0,
        status: 0,
        currentPOStartDate: null,
        currentPOEndDate: null,
        purchasedSearchCount: 0
        // searchesEndDate: moment(Date.now()).format()
      },
      CurrentSearches: {
        currentPOStartDate: null,
        currentPOEndDate: null,
        purchasedSearchCount: 0,
        activatedSeearchCount: 0
      },
      orgs: [],
      curAclicks: [],
      AclickByOrgId: {}
    }
  },
  created () {
    this.loading = true
    BaseService.GetOrgs(this.header).then(res => {
      if (res.data.success) {
        this.orgs = res.data.result
        BaseService.GetAClicks(this.header).then(res => {
          if (res.data.success) {
            this.curAclicks = res.data.result
            this.loading = false
          }
        })
      }
    })
  },
  methods: {
    filterAclicks () {
      console.log(this.NewTransactionItem.orgid)
      console.log(this.curAclicks)
      this.AclickByOrgId = this.curAclicks.find(x =>
        x.organisationId === this.NewTransactionItem.orgid
      )
      this.CurrentSearches.purchasedSearchCount = this.AclickByOrgId.searchCountPurchased
      this.CurrentSearches.activatedSeearchCount = this.AclickByOrgId.lastActivatedSearches
      this.CurrentSearches.currentPOStartDate = this.AclickByOrgId.startDate
      this.CurrentSearches.currentPOEndDate = this.AclickByOrgId.endDate

      console.log(this.AclickByOrgId)
    },
    save () {
      this.NewTransactionItem.activationDateTime = this.NewTransactionItem.activationDateTime ? moment(this.NewTransactionItem.activationDateTime).format('YYYY-MM-DD') : null
      this.NewTransactionItem.searchesEndDate = this.NewTransactionItem.searchesEndDate ? moment(this.NewTransactionItem.searchesEndDate).format('YYYY-MM-DD') : null
      this.NewTransactionItem.currentPOStartDate = this.CurrentSearches.currentPOStartDate ? moment(this.CurrentSearches.currentPOStartDate).format('YYYY-MM-DD') : null
      this.NewTransactionItem.currentPOEndDate = this.CurrentSearches.currentPOEndDate ? moment(this.CurrentSearches.currentPOEndDate).format('YYYY-MM-DD') : null
      this.NewTransactionItem.purchasedSearchCount = this.CurrentSearches.purchasedSearchCount
      this.NewTransactionItem.activatedSeearchCount = this.CurrentSearches.activatedSeearchCount

      BaseService.SaveTr(this.header, this.NewTransactionItem)
        .then(res => {
          console.log(res)
          if (res.status === 200) {
            this.NewTransactionItem = {
              orgid: 0,
              orgname: '',
              activatedSeearchCount: 0,
              transactionSearchCount: 0,
              activationDateTime: 0,
              searchesEndDate: null,
              transactionTypeId: 0,
              status: 0,
              currentPOStartDate: null,
              currentPOEndDate: null,
              purchasedSearchCount: 0
              // searchesEndDate: moment(Date.now()).format()
            }
            this.CurrentSearches = {
              currentPOStartDate: null,
              currentPOEndDate: null,
              purchasedSearchCount: 0,
              activatedSeearchCount: 0
            }
            this.$bvModal.hide('addNewTr')
          }
        })
    },
    close () {
      this.NewTransactionItem = {
        orgid: 0,
        orgname: '',
        activatedSeearchCount: 0,
        transactionSearchCount: 0,
        activationDateTime: 0,
        searchesEndDate: null,
        transactionTypeId: 0,
        status: 0,
        currentPOStartDate: null,
        currentPOEndDate: null,
        purchasedSearchCount: 0
        // searchesEndDate: moment(Date.now()).format()
      }
      this.CurrentSearches = {
        currentPOStartDate: null,
        currentPOEndDate: null,
        purchasedSearchCount: 0,
        activatedSeearchCount: 0
      }
      this.$bvModal.hide('addNewTr')
    }
  }
}
</script>

 <style>
    #bdate {
      height: calc(1.5em + 0.376rem + 2px)!important;
      padding: 0.188rem 0.625rem;
      font-size: 0.75rem;
      line-height: 1.5;
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
    }
    .input-group-text{
      height: calc(1.5em + 0.376rem + 2px)!important;
      padding: 0;
      max-height: calc(1.5em + 0.376rem - 1px);
    }
    .input-group-prepend {
      height: calc(1.5em + 0.376rem + 2px)!important;
    }
    :root {
      --dp-button-icon-height: 20px;
    }
    .vdp-datepicker__calendar {
      z-index: 1000!important;
      position: relative!important;
    }
    .collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}
  </style>
